// extracted by mini-css-extract-plugin
export default {"viewLabel":"ExistingSupplierRegistration_viewLabel__TRqmR"};